/* Toast « ajouté au panier », en remplacement du tiroir latéral.
   Minimog émet product-ajax:added sur document avec la ligne de panier
   renvoyée par /cart/add.js, que le tiroir soit actif ou non. */
(function () {
  var AUTO = 5200;
  var boite, chrono, muet = false;

  function noeud() {
    return document.getElementById('gu-toast');
  }

  function vignette(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
  }

  function poser(sel, texte) {
    var e = boite.querySelector(sel);
    if (!e) return;
    e.textContent = texte || '';
    e.hidden = !texte;
  }

  function caler() {
    // Le toast se place sous l'en-tête, sticky ou non, au moment de l'ouverture.
    var h = document.querySelector('.m-header, header');
    var bas = h ? h.getBoundingClientRect().bottom : 0;
    boite.style.top = Math.max(12, bas + 12) + 'px';
  }

  function fermer() {
    if (!boite) return;
    clearTimeout(chrono);
    boite.classList.remove('is-open');
    setTimeout(function () {
      if (!boite.classList.contains('is-open')) boite.hidden = true;
    }, 260);
  }

  function ouvrir(ligne) {
    boite = boite || noeud();
    if (!boite) return;

    var img = boite.querySelector('.gu-toast__img');
    var src = ligne.image || (ligne.featured_image && ligne.featured_image.url);
    if (src) {
      img.src = vignette(src);
      img.alt = ligne.product_title || '';
      img.hidden = false;
    } else {
      img.hidden = true;
    }

    poser('.gu-toast__titre', ligne.product_title || ligne.title || '');

    var bouts = [];
    if (ligne.variant_title && ligne.variant_title !== 'Default Title') {
      bouts.push(ligne.variant_title);
    }
    // /cart/add.js renvoie le total de la ligne, pas ce qui vient d'etre ajoute.
    var q = ligne.quantity || 1;
    bouts.push(q + (q > 1 ? ' pezzi' : ' pezzo') + ' nel tuo carrello');
    poser('.gu-toast__meta', bouts.join(' · '));

    boite.hidden = false;
    caler();
    // Forcer un reflow pour que la transition reparte même sur un ajout enchaîné.
    boite.classList.remove('is-open');
    void boite.offsetWidth;
    boite.classList.add('is-open');

    clearTimeout(chrono);
    chrono = setTimeout(fermer, AUTO);
  }

  function museler() {
    // Minimog pousse sa propre notification texte : elle ferait doublon.
    var N = window.MinimogTheme && window.MinimogTheme.Notification;
    if (!N || N.__mds) return !!N;
    var vrai = N.show;
    N.show = function (opts) {
      if (opts && opts.type === 'success') return;
      return vrai.call(N, opts);
    };
    N.__mds = true;
    return true;
  }

  function brancher() {
    boite = noeud();
    if (!boite) return;

    boite.addEventListener('click', function (e) {
      if (e.target.closest('[data-gu-toast-close]')) fermer();
    });
    // La lecture ne doit pas être coupée par le minuteur.
    boite.addEventListener('mouseenter', function () { clearTimeout(chrono); });
    boite.addEventListener('mouseleave', function () {
      chrono = setTimeout(fermer, 2200);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });

    document.addEventListener('product-ajax:added', function (e) {
      var ligne = e && e.detail && e.detail.product;
      if (ligne) ouvrir(ligne);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brancher);
  } else {
    brancher();
  }

  // vendor.js est en defer : MinimogTheme peut arriver après nous.
  var essais = 0;
  var attente = setInterval(function () {
    if (muet || museler() || ++essais > 40) {
      muet = true;
      clearInterval(attente);
    }
  }, 100);
})();